import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { dbas } from '../../../../../redux/dbas/action';
import { selectDbasListItems } from '../../../../../redux/dbas/selector';
import DBATypeComponent from '../component/dba-type.component';
import { libraryData } from '../../../e-applications/settlement-hub/constants/constants';
import { selectListItems } from '../../../../../redux/library/selector';

const DBATypeMappings= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(true)
   const dbasItems = useSelector(selectDbasListItems)
   const libraryData = useSelector(selectListItems)
   const params: any = useParams();
  const [
    selectedDba,
    setSelectedDba
  ] = useState<any>([])
 
  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDba({ ...selectedDba, [field]: event });
  }

  useEffect(
    () => {
            dispatch(dbas.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/platform-dbas/list`,entity:'domains',jsonData:{}
        }))
        setIsLoading(false)
    },
    []
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
   
      await dispatch(dbas.resetAction({ actionType: 'create' }))
     await dispatch(dbas.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-type-dba-mappings`,entity:'dbass',jsonData:{
      Context:{},     
    Records: [
      
        
       {
        DBAId: params?.id,
        DBATypeId: selectedDba?.DBATypeId
       }
        
    
     
    
      
    ]
 
}})).then(()=>{
  back()
})

  }

const back=()=>{
  navigate('/management/dbn-cloud/dbas')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <DBATypeComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDba={selectedDba}
           back={back}
           handleFormSubmit={handleFormSubmit}
           dbas={libraryData?.result?.DBAType}
         
          /> 
    } 
          </>
    )
    
    }
   
    export default DBATypeMappings;
